module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/hero_mob-a1de032eef0595cd44846374a0c758ad.jpg";